import { render } from "./SingleItemImage.vue?vue&type=template&id=a5fb4576&scoped=true"
import script from "./SingleItemImage.vue?vue&type=script&lang=js"
export * from "./SingleItemImage.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5fb4576"]])

export default __exports__